// Where a signed-in visitor continues into founding checkout.
//
// /pricing is the existing founding_beta purchase step. Pricing.jsx posts
// /api/payments/v1/checkout/session with the anonymous fsrs_client_id, and
// it refuses that call until the Terms checkbox is checked. Landing claim
// buttons have no terms control, so they land here instead of opening a
// Stripe session themselves.
export const FOUNDING_ENTRY_PATH = "/pricing";

// mode "login" opens the auth modal on the login form (POST /api/auth/login).
// mode "signup" opens account creation. Claim buttons omit mode and use signup.
// A visitor who already has a session skips both forms and continues to pricing.
export function resolveFoundingEntry(loggedIn, mode = "signup") {
    if (loggedIn) return { type: "pricing", path: FOUNDING_ENTRY_PATH };
    if (mode === "login") return { type: "login" };
    return { type: "signup" };
}
